import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsPhabricatorComponent } from './simple-icons-phabricator.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsPhabricatorComponent ],
    exports:      [ SimpleIconsPhabricatorComponent ],
    bootstrap:    []
})
export class SimpleIconsPhabricatorModule {}
